// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"586b53ef","937":"351708ff"}[chunkId] + ".chunk.js";
};